// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"658":"59e3b3ca","902":"98ba5112"}[chunkId] + ".chunk.js";
};